export default __webpack_public_path__ + "static/media/ic-pt.deef61c0.svg";